import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as fromUser from '@app/store/user';
import { Router } from '@angular/router';
import { UserStatusService } from '@app/services/user-status.service';
import { GeneralService } from '@app/services/general.service';

@Component({
  selector: 'app-user-status',
  templateUrl: './user-status.component.html'
})
export class UserStatusComponent implements OnInit, OnDestroy {
  isOnline: boolean = false;
  private subscription = new Subscription();

  constructor(
    private store: Store,
    private router: Router,
    private userStatusService: UserStatusService,
    private generalService: GeneralService
  ) {}

  ngOnInit(): void {
    // Verificar si estamos en la página de login
    if (this.router.url.includes('/auth/login')) {
      return;
    }

    // ✅ Esperar un momento antes de suscribirse para evitar duplicados durante el login
    setTimeout(() => {
      const userId = this.generalService.getUserId();
      if (userId) {
        this.subscription.add(
          this.userStatusService.getUserStatus(userId).subscribe(
            (status: string) => {
              this.isOnline = status === 'ONLINE';
              // Actualizar el estado en localStorage para mantener compatibilidad
              localStorage.setItem('userStatus', status);
            }
          )
        );

        // ✅ Verificar el estado inicial desde localStorage
        this.checkUserStatusFromStorage();

        // ✅ Escuchar cambios en localStorage (para detectar cambios de otras pestañas/componentes)
        window.addEventListener('storage', (e) => {
          if (e.key === 'userStatus' && e.newValue) {
            this.isOnline = e.newValue === 'ONLINE';
            console.log('👤 Estado actualizado desde storage event:', e.newValue);
          }
        });

        // ❌ REMOVIDO: La conexión ahora se hace automáticamente en el login
        // this.userStatusService.connectCurrentUser();
      }
    }, 500); // Esperar 500ms para evitar duplicados durante el login

    // Actualizar actividad del usuario cada 5 minutos (solo si no estamos en login)
    // ⚠️ ESPERAR 2 minutos antes del primer intento para evitar conflictos con el login
    setTimeout(() => {
      const activityInterval = setInterval(() => {
        // No actualizar actividad si estamos en la página de login
        if (!this.router.url.includes('/auth/login')) {
          console.log('🔄 Actualizando actividad del usuario (intervalo de 5 min)');
          // ✅ Actualizar actividad del usuario
          this.userStatusService.updateCurrentUserStatus(true);
        }
      }, 300000); // 5 minutos

      // Limpiar intervalo al destruir componente
      this.subscription.add(() => clearInterval(activityInterval));
    }, 120000); // Esperar 2 minutos antes de iniciar el intervalo
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Verifica y actualiza el estado del usuario desde localStorage
   */
  private checkUserStatusFromStorage(): void {
    const storedStatus = localStorage.getItem('userStatus');
    const newIsOnline = storedStatus === 'ONLINE';

    if (this.isOnline !== newIsOnline) {
      this.isOnline = newIsOnline;
      console.log('🔍 Estado actualizado desde localStorage:', newIsOnline ? 'ONLINE' : 'OFFLINE');
    }
    // Removido: logs innecesarios cuando no hay cambios
  }
}
